import { Metadata } from '@redwoodjs/web';
import { PageBody } from 'src/components/containers/PageBody';
import { PageHeader, PageType } from 'src/components/containers/PageHeader';

export default function DocumentSettingsPage() {
  return (
    <>
      <Metadata title="Document Settings" />
      <PageHeader pageType={PageType.DocumentSettings}></PageHeader>
      <PageBody>todo</PageBody>
    </>
  );
}
